import { storage } from '@wiloke/functions';

export const isNguyenDttnMode = () => {
  return storage.getItem('nguyenDttn') === 'on';
};
